import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type AdminBackgroundState } from "@/layouts/AdminBackgroundLayout/AdminBackgroundLayout.types";
import type { RootState } from "@/store";

const initialState: AdminBackgroundState = {
  imageUrl: null,
  isImageLoaded: false,
};

const adminBackgroundSlice = createSlice({
  name: "adminBackgound",
  initialState,
  reducers: {
    setAdminBackgroundUrl: (state, action: PayloadAction<string | null>) => {
      state.imageUrl = action.payload;
      state.isImageLoaded = false;
    },
    setAdminImageLoaded: (state, action: PayloadAction<boolean>) => {
      state.isImageLoaded = action.payload;
    },
  },
});

export const { setAdminBackgroundUrl, setAdminImageLoaded } =
  adminBackgroundSlice.actions;

// Selectors
export const selectAdminBackgroundUrl = (state: RootState) =>
  state.adminBackground.imageUrl;
export const selectAdminIsImageLoaded = (state: RootState) =>
  state.adminBackground.isImageLoaded;
export default adminBackgroundSlice.reducer;
